/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import FormInput from "../../../../../monitoring/src/Components/Common/FormInput";
import React from "react";

export const DateTimeFieldEditor = props => {
	const {Value, OnUpdate, FieldDef} = props;

	const handleChange = (value) => {
		const formattedValue = value ? DateUtils.FormatToUTCDateTime(value) : value;
		OnUpdate(formattedValue);
	}

	return <FormInput
		type="datetime-local"
		value={DateUtils.FormatToLocalDateTime(Value)}
		onChange={handleChange}
		placeholder={FieldDef?.placeholder}
		required
	/>
};
